import React from "react"

import { Flex } from "@chakra-ui/react"
import { GatsbyImage } from "gatsby-plugin-image"

export default function PostImage({ image }) {
  return (
    <Flex w={{ base: "full", md: 1 / 3, lg: "full", xl: 1 / 3 }} bg="base.d700">
      <GatsbyImage alt="sd" image={image} />
    </Flex>
  )
}
